/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IGdnPromoProgramViewProps } from './gdn-promo-program';

export default (props: IGdnPromoProgramViewProps) => {
    const { moduleProps, promoContentProps, addToOrderTemplate, modal } = props;

    return (
        <Module {...moduleProps}>
            {/* eslint-disable-next-line react/no-danger -- Promotional markup is authored by Gardner in Site Builder. */}
            <div {...promoContentProps} />
            {addToOrderTemplate}
            {modal}
        </Module>
    );
};
